import { asAmount } from "@goodfill/domain-properties";
import { DecimalRange } from "../../../filters/DecimalRangeFilter";
import { FinalCommissionAmountComponent } from "@goodfill/domain-properties-components";
import { decimalRangeFilter, DecimalRangeColumnDefinition } from "../generic/DecimalRangeColumnDefinition";

export const FINAL_COMMISSION_AMOUNT_CRITERIA_KEY = "finalCommissionAmount";

type CriteriaValue = DecimalRange;
type Criteria = { [FINAL_COMMISSION_AMOUNT_CRITERIA_KEY]: CriteriaValue };
type FilterChangeFunction = (key: typeof FINAL_COMMISSION_AMOUNT_CRITERIA_KEY, value: CriteriaValue) => void;

export const finalCommissionAmountFilter = <TItemKey extends string>(key: TItemKey) =>
  decimalRangeFilter(FINAL_COMMISSION_AMOUNT_CRITERIA_KEY, key);

export const FinalCommissionAmountColumnDefinition = <TItemKey extends string>(
  itemKey: TItemKey,
  criteria: Criteria,
  onFilterChange: FilterChangeFunction,
) =>
  DecimalRangeColumnDefinition({
    name: "Commission",
    itemKey,
    criteriaKey: FINAL_COMMISSION_AMOUNT_CRITERIA_KEY,
    criteria,
    onFilterChange,
    itemRenderer: (row) => <FinalCommissionAmountComponent value={asAmount(row[itemKey])} />,
    rangeFilterProps: { leftIcon: "$" },
  });
